import React, { useEffect /* , useState  */ } from 'react';
import PropTypes from 'prop-types';
import Avatar from 'components/common/Avatar';
import Input from 'components/common/Input';
import Flex from 'components/common/Flex';
import { Collapse, Row } from 'react-bootstrap';

const NequiForm = ({ show, src, register, setValue, errors }) => {
 useEffect(() => {
  if (show) setValue('payment_method', { type: 'NEQUI', phone_number: '' });
 }, [show]);

 return (
  <Collapse in={show} appear>
   <div id="example-collapse-text">
    <div>
     <Flex className="fs--1 mb-3">
      <Avatar src={src} size={'2xl'} className="me-3" />
      <div className="flex-1 ps-3 border-start border-start-dark">
       <h5 className="mb-0 text-primary">
        <span className="bg-100 dark__bg-1100 pe-3">Nequi</span>
       </h5>
       <span className="bg-100 dark__bg-1100 pe-3">
        Recibiras una <strong>notificación push</strong> en tu celular.
       </span>
      </div>
     </Flex>

     <Input
      type="text"
      errors={errors}
      label="Número Nequi*"
      name={['payment_method', 'phone_number']}
      placeholder="NEQUI"
      formLabelProps={{
       column: true,
       xs: 12,
       sm: 6,
       className: 'text-lg-end'
      }}
      formColumnProps={{ xs: 12, sm: 6, className: 'text-info' }}
      formGroupProps={{
       as: Row,
       className: 'my-3'
      }}
      formControlProps={{
       ...register('payment_method.phone_number', {
        required: 'Debe especificar un numero nequi',
        validate: value => !/[^0-9]/g.test(value) || 'Solo debe contener numeros',
        minLength: { value: 10, message: 'Debe ser un numero valido' }
       }),
       maxLength: 10,
       autoComplete: 'off'
      }}
     />
     <span className="bg-100 dark__bg-1100 pe-3 fs--1 mt-4 long-polling-text">
      Por favor{' '}
      <em>
       <strong>confirma la transacción en tu celular</strong>
      </em>{' '}
      cuando te llegue la{' '}
      <em>
       <strong>notificación push.</strong>
      </em>{' '}
      <br />
      Si no te ha llegado,{' '}
      <em>
       <strong> verifica que tengas Nequi instalado </strong>
      </em>{' '}
      en tu celular y que ya estés registrado.
     </span>
    </div>
   </div>
  </Collapse>
 );
};

NequiForm.propTypes = {
 show: PropTypes.bool.isRequired,
 src: PropTypes.string,
 register: PropTypes.func,
 setValue: PropTypes.func,
 errors: PropTypes.object
};

export default NequiForm;
